import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import HomeLP from '../components/HomeLP';
import PreloadResources from '../components/PreloadResources';
import { BLACK_NOV_CAMPAIGN } from '@/data/offers';

const isOver = (endsAt?: string) => !!endsAt && Date.now() > new Date(endsAt).getTime();

// Black November: mesma página da home, com o combo e o cupom BLACK30NOV26 no checkout.
// Depois do fim da promoção, manda para a home mantendo as UTMs do link.
const BlackNovPage = () => {
  const { search } = useLocation();

  if (isOver(BLACK_NOV_CAMPAIGN.endsAt)) return <Navigate to={`/${search}`} replace />;

  return (
    <>
      <PreloadResources lcpImagePath="/lovable-uploads/e4b1575d-1cfa-44be-a5dc-60500d1054b7.png" />
      <HomeLP campaign={BLACK_NOV_CAMPAIGN} />
    </>
  );
};

export default BlackNovPage;
